import { Typography } from "@mui/material";
import React from "react";
import { Empresa } from "../../../../Hooks/UsuarioHook";
import { useSeletor } from "../../../../Storage/seletor";
import { useUsuarioNaoEmiteNota } from "../../../../Hooks/UsuarioNaoEmiteNotaHook";

interface Props {
  empresa: Empresa;
  periodoInicial: {
    mes: number;
    ano: number;
  };
  periodoFinal: {
    mes: number;
    ano: number;
  };
}
export function HeaderRelatorioImpresso({
  empresa,
  periodoInicial,
  periodoFinal,
}: Props) {
  const{usuarioNaoEmiteNota} = useUsuarioNaoEmiteNota();
  const { alterados } = useSeletor();
  return (
    <div
      style={{ paddingRight: "60px", paddingLeft: "60px", marginTop: "32px" }}
    >
      {(empresa && empresa.CODIGO_FIRMA)||(usuarioNaoEmiteNota.CODIGO) ? (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="h5"
              component="h1"
              style={{ fontSize: "14px" }}
            >
              {empresa?.DESCRICAO}
            </Typography>
            <Typography
              variant="h5"
              component="h1"
              style={{
                fontSize: "14px",
              }}
            >
              {alterados
                ? "Iss informado com valores alterados"
                : "Iss informado"}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Typography
              variant="h5"
              component="h1"
              style={{ fontSize: "12px" }}
            >
              Período: {periodoInicial.mes.toString().padStart(2, "0")}/
              {periodoInicial.ano} até{" "}
              {periodoFinal.mes.toString().padStart(2, "0")}/{periodoFinal.ano}
            </Typography>
          </div>
        </>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
          }}
        >
          <Typography variant="h5" component="h1" style={{ fontSize: "14px" }}>
            Arrecadação de ISS referente ao período de {periodoInicial.mes}/
            {periodoFinal.ano} a {periodoFinal.mes}/{periodoFinal.ano}
          </Typography>
        </div>
      )}
    </div>
  );
}
